export function Aceptacion(apellido, codigo) {
    let dialogo =
        "Directora: Minerva McGonagall (Orden de Merlín, Primera Clase, Gran Hechicera, Jefa Suprema, etc.)\n"
        + "Estimado(A) señor(A) " + apellido + ":\n"
        + "Nos complace informarle que tiene una plaza en el Colegio Hogwarts de Magia y Hechicería. Adjunto encontrará una lista del equipo y los libros necesarios.\n"
        + "El curso comienza el 1 de septiembre. Esperamos su lechuza antes del 31 de julio.\n"
        + "Su codigo de confirmación es el: " + codigo + "\n"
        + "Atentamente,\n"
        + "Minerva McGonagall\n"
        + "Subdirectora\n";
    return dialogo;
}

export function Recuperacion(codigo) {
    let dialogo =
        "Directora: Minerva McGonagall (Orden de Merlín, Primera Clase, Gran Hechicera, Jefa Suprema, etc.)\n"
        + "\n"
        + "Estimado(A) Alumno(A):\n"
        + "Espero que este mensaje le encuentre en pleno uso de sus facultades mentales y mágicas.\n"
        + "Se ha solicitado recientemente la recuperación de acceso a un sistema bajo su nombre. En atención a dicha solicitud, se le ha generado un código único que deberá utilizar con la mayor discreción y prontitud. Le advierto que este código no debe ser compartido bajo ninguna circunstancia, ni siquiera con elfos domésticos de confianza.\n"
        + "Código de recuperación: " + codigo + "\n"
        + "Dispone usted de un tiempo limitado para utilizar este código antes de que expire, así que le insto a no postergar su aplicación. Si esta solicitud no fue realizada por usted, le exhorto a notificarlo de inmediato a las autoridades pertinentes. No toleraremos ningún tipo de travesura tecnológica.\n"
        + "Atentamente,\n"
        + "Minerva McGonagall\n"
        + "Subdirectora\n";

    return dialogo;

}

export function Asignacion(nombre, text, casa) {
    let dialogo =
        "¿Asi que tu eres " + nombre + " he?\n " + text + " no se, es muy dificil, creo que te pondre en. . . \n\n¡" + casa + "!"
    return dialogo;
}

export function Text(casa) {
    let text = "";
    //log.e("casa", casa);
    switch (casa) {
        case "GRYFFINDOR":
            text = "¡Siempre valientes y audaces! Muy bien, valiente, pero algo temeroso...";
            break;
        case "HUFFLEPUFF":
            text = "¡Trabajo duro y lealtad! No tan rápido en la toma de decisiones, pero con una gran capacidad para la amistad y el trabajo en equipo...";
            break;
        case "RAVENCLAW":
            text = " ¡Sabiduría y creatividad! Tus pensamientos son agudos y tu mente brilla...";
            break;
        case "SLYTHERIN":
            text = "¡un lugar de astucia y ambición! La ambición corre por tus venas...";
            break;
    }
    return text;
}


export function Acerca() {
    let text = "La escoba encantada es una pequeña cafetería fundada el 9 de marzo del año 2024, sus fundadores comenzaron imaginando un sueño que pronto se haría realidad en un pequeño establecimiento que tiene lugar en av.Francisco Villa, esquina con Artemio Basurto.\n\n"
        + "En la escoba encantada podrás encontrar muchísimas curiosidades y buenos momentos, pero, sobre todo, podrás encontrar sabores inolvidables, desde una chapata o un delicioso café, hasta su delicioso postre insignia, el famoso mostachón.\n\n"
        + "Acompáñanos a vivir la experiencia de tu saga favorita en compañía de nosotros, pues, aunque nuestro lugarcito es pequeño, te aseguramos que te haremos sentir como en casa.\n"
    return text;
}